const initialState = {
  emails: [],
  lastDoc: null,
  hasMore: true,
};

const NewsletterEmailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_NEWSLETTER_EMAILS":
      return {
        ...state,
        emails: action.payload.formattedEmails,
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };

    case "ADD_MORE_NEWSLETTER_EMAILS":
      return {
        ...state,
        emails: [...state.emails, ...action.payload.formattedEmails],
        lastDoc: action.payload.lastDoc,
        hasMore: action.payload.hasMore,
      };

    case "RESET_NEWSLETTER_EMAILS":
      return initialState;

    default:
      return state;
  }
};

export default NewsletterEmailsReducer;
